module.exports = {
      id: "icon-audio-next-usage",
      viewBox: "0 0 35.504 35.504",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-audio-next",
      toString: function () {
        return this.url;
      }
    }